<template>
  <div
    class="container-fluid portlet_wrapper"
    :class="{
      [`portlet__${variant}`]: !!variant
    }"
  >
    <div class="portlet_header row">
      <div class="col-12">
        <slot name="header" />
      </div>
    </div>
    <div class="portlet_content row">
      <div class="col-12">
        <slot />
      </div>
    </div>
    <div class="portlet_footer row">
      <div class="col-12">
        <slot name="footer" />
      </div>
    </div>
  </div>
</template>
<script>
import '~style/components/portlet.scss'
export default {
  name: 'Portlet',
  props: {
    variant: {
      type: String,
      default: ''
    }
  }
}
</script>
